<template>
  <div class="home-page">

    <!-- 轮播 Banner -->
    <section class="hero-banner">
      <!-- 数量为 1 时，显示单张图片 -->
      <div v-if="bannerSlides.length === 1" class="single-banner">
        <img :src="bannerSlides[0].carouselUrl" style="width: 100%; height: 100%; object-fit: cover;">
      </div>

      <!-- 数量大于 1 时，显示轮播幻灯片 -->
      <template v-else-if="bannerSlides.length > 1">
        <div class="banner-slider">
          <div
            v-for="(slide, idx) in bannerSlides"
            :key="idx"
            class="banner-slide"
            :class="{ active: currentBanner === idx }"
          >
            <div class="banner-placeholder">
              <div class="banner-text-overlay">
                <img :src="slide.carouselUrl" style="width: 100%; height: 100%; object-fit: cover;">
              </div>
            </div>
          </div>
        </div>
        <button class="banner-arrow banner-prev" @click="prevBanner">&#10094;</button>
        <button class="banner-arrow banner-next" @click="nextBanner">&#10095;</button>
        <div class="banner-dots">
          <span
            v-for="(s, i) in bannerSlides"
            :key="i"
            :class="{ active: currentBanner === i }"
            @click="currentBanner = i"
          ></span>
        </div>
      </template>
    </section>

    <!-- 热门资产 -->
    <section class="assets-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">热门资产</h2>
          <router-link :to="`/assets?id=${assetsScode}&contenttpl=sys_content_type_property_01`" class="view-more">查看更多 ›</router-link>
        </div>
        
        <div class="assets-carousel-wrapper" @mouseenter="stopAssetSlideTimer" @mouseleave="startAssetSlideTimer">
          <div class="assets-carousel-track" :style="{ transform: `translateX(-${currentAssetSlide * 100}%)` }">
            <div class="assets-slide" v-for="(group, groupIdx) in chunkedHotAssets" :key="groupIdx">
              <div class="assets-grid solo-grid">
                <div class="asset-card-detailed" v-for="asset in group" :key="asset.id">
                  <div class="asset-image">
                    <router-link :title="asset.assetName" :to="{ path: '/property/detail', query: { id: asset.assetId } }" target="_blank">
                      <img 
                        :src="asset.coverImage"
                        style="width: 100%; height: 100%; object-fit: cover;"
                        :defaultimg="asset.defaultImg">
                      <span class="asset-tag tag-top" v-if="asset.isTop === '1' || asset.isTop === 1">
                        <i class="el-icon-top"></i>Top
                      </span>
                    </router-link>
                  </div>
                  <div class="asset-info">
                    <router-link :title="asset.assetName" :to="{ path: '/property/detail', query: { id: asset.assetId } }" target="_blank" style="text-decoration: none;">
                      <h3>{{ asset.assetName }}</h3>
                    </router-link>
                    <div class="asset-meta">
                      <span class="addr-span"><i class="el-icon-location-outline"></i> {{ asset.address }}</span>
                      <span class="tag-span"><i class="el-icon-price-tag"></i> {{ asset.categoryName }}</span>
                    </div>
                    <div class="asset-details">
                        <div class="detail-item">
                          <span class="label" v-if="asset.assetValueType === 0">参考估值 面议</span>
                          <span class="label" v-else>参考估值 <strong style="color: #333">￥{{ asset.priceMin }}万元-{{ asset.priceMax }}万元</strong></span>
                        </div>
                    </div>
                    
                    <div class="asset-footer">
                      <div class="asset-stats" v-if="$store.state.siteConfig.showVisits === '1'">
                        <span ><i class="el-icon-view"></i> {{ asset.visits || 0 }}次浏览</span>
                        <span v-if="asset.isRecommended === 'Y'" class="tag tag-recommend" style="margin-left: 8px;"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>优质</span>
                      </div>
                       <span v-else-if="asset.isRecommended === 'Y'" class="tag tag-recommend"><i class="el-icon-star-on" style="margin-right:2px; font-size: 0.8rem;"></i>优质</span>
                      <router-link :title="asset.assetName" :to="{ path: '/property/detail', query: { id: asset.assetId } }" target="_blank" class="btn-view">查看详情</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 轮播指示器 -->
          <div class="assets-carousel-dots" v-if="chunkedHotAssets.length > 1">
            <span 
              v-for="(dot, dotIdx) in chunkedHotAssets" 
              :key="dotIdx"
              :class="{ active: currentAssetSlide === dotIdx }"
              @click="setAssetSlide(dotIdx)"
            ></span>
          </div>
        </div>
      </div>
    </section>

    <!-- 新闻公告 -->
    <section class="news-section">
      <div class="container">
        <div class="news-grid">
          <!-- 公司新闻 -->
          <div class="news-block">
            <div class="block-header">
              <h3>公司新闻</h3>
              <router-link to="/news?id=73583300ab1a4fd599ea8e380ae8e342&contenttpl=sys_content_type_property_01" class="more-link">查看更多 ›</router-link>
            </div>
            <div class="news-list" style="padding: 25px 25px;">
              <div class="news-item featured" v-if="companyNews != null && companyNews.length > 0">
                <router-link :title="companyNews[0].title" :to="{ path: '/news/detail', query: { id: companyNews[0].id, from: 'news' } }" target="_blank" :style="{color: companyNews[0].titlecolor != '' ? companyNews[0].titlecolor:'#333333'}">
                  <div class="news-image-featured">
                    <!-- <img :src="companyNews[0].ico"> -->
                    <img
                        :src="companyNews[0].ico"
                        style="width: 100%; height: 100%; object-fit: cover;"
                        :defaultimg="companyNews[0].defaultImg">
                  </div>
                </router-link>
                <div class="news-content-featured">
                  <h4><router-link :title="companyNews[0].title" :to="{ path: '/news/detail', query: { id: companyNews[0].id, from: 'news' } }" target="_blank" :style="{color: companyNews[0].titlecolor != '' ? companyNews[0].titlecolor:'#333333'}">{{companyNews[0].title}}</router-link></h4>
                  <span class="news-date">{{companyNews[0].date}}</span>
                </div>
              </div>
              <div class="news-item list-item" v-for="(n, index) in companyNews" :key="n.id" v-if="index > 0">
                <span class="news-dot"></span>
                <router-link :title="n.title" :to="{ path: '/news/detail', query: { id: n.id, from: 'news' } }" target="_blank" :style="{color: n.titlecolor != '' ? n.titlecolor:'#333333'}">
                  {{ n.title }}
                </router-link>
                <span class="news-date">{{ n.date }}</span>
              </div>
            </div>
          </div>
          <!-- 通知公告 -->
          <div class="news-block">
            <div class="block-header">
              <h3>处置公告</h3>
              <router-link to="/assets?id=6d890d197c214534b66f491f9ff7bc0a&contenttpl=sys_content_type_news_03" class="more-link">查看更多 ›</router-link>
            </div>
            <div class="news-list">
              <div class="news-item list-item" v-for="n in notices" :key="n.id">
                <!-- <span class="tag" :class="itemTagClass(n)">{{ getInfoTypeStr(n.infoType) }}</span> -->
                <router-link :title="n.title" :to="{ path: '/news/detail', query: { id: n.id, from: 'news' } }" target="_blank" :style="{color: n.titlecolor != '' ? n.titlecolor:'#333333'}">
                  {{ n.title }}
                </router-link>
                <span class="news-date">{{ n.date }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业党建 -->
    <section class="party-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">企业党建</h2>
          <router-link :to="{ path: '/party/list', query: { id: '8f64946557ac4ad5823b4c5aee20f7c1', tab: 'sys_content_type_news_05'} }" class="view-more">查看更多 <i class="el-icon-right"></i></router-link>
          <!-- <router-link to="/news?id=23&contenttpl=sys_content_type_news_05" class="view-more">查看更多 <i class="el-icon-right"></i></router-link> -->
        </div>
        <div class="dynamics-grid">
          <router-link :title="partyDynamics[0].title" class="dynamic-card featured" v-if="partyDynamics != null && partyDynamics.length > 0" :to="{ path: '/news/detail', query: { id: partyDynamics[0].id, from: 'party' } }" target="_blank">
            <div class="dynamic-image">
               <!-- <img :src="partyDynamics[0].ico" style="width: 100%; height: 100%; object-fit: cover;"/> -->
                <img
                  :src="partyDynamics[0].ico"
                  style="width: 100%; height: 100%; object-fit: cover;"
                  :defaultimg="partyDynamics[0].defaultImg">
               <!-- <span class="dynamic-tag">置顶</span> -->
            </div>
            <div class="dynamic-content">
              <h4>{{ partyDynamics[0].title }}</h4>
              <p>{{ partyDynamics[0].description }}</p>
              <div class="dynamic-meta">
                <span><i class="el-icon-date"></i> {{ partyDynamics[0].date }}</span>
                <span v-if="$store.state.siteConfig.showVisits === '1'"><i class="el-icon-view"></i> {{ partyDynamics[0].visits }}</span>
              </div>
            </div>
          </router-link>
          <div class="dynamic-list">
            <div class="dynamic-item" v-for="(d, index) in partyDynamics" :key="index" v-if="index >= 1">
              <div class="dynamic-date">
                <span class="day">{{ formatDateParts(d.date).day }}</span>
                <span class="month">{{ formatDateParts(d.date).month }}</span>
              </div>
              <div class="dynamic-info">
                <h5><router-link :title="d.title" :to="{ path: '/news/detail', query: { id: d.id, from: 'party'} }" target="_blank" :style="{color: d.titlecolor != '' ? d.titlecolor:'#333333'}">{{ d.title }}</router-link></h5>
                <p>{{ d.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业理念 -->
    <section class="motto-section">
      <div class="container">
        <div class="motto-quote">
          <svg class="quote-mark left" viewBox="0 0 1195 1024" xmlns="http://www.w3.org/2000/svg"><path d="M1125.400405 972.814933 651.636395 972.814933 651.636395 631.106304C651.636395 491.702016 663.719168 382.333696 687.885227 302.997931 712.0512 223.662165 737.181781 170.700459 802.935893 107.231829 868.68992 43.763285 914.312789 24.717568 1010.828373 0L1078.255957 145.030059C1010.828373 170.796971 969.749333 182.289237 906.391381 248.024235 843.033429 313.759232 838.360149 377.340075 838.360149 431.988736L1125.400405 431.988736 1125.400405 972.814933ZM473.764096 972.814933 0 972.814933 0 631.106304C0 491.702016 12.082859 382.333696 36.248832 302.997931 60.414891 223.662165 85.545472 170.700459 151.299499 107.231829 217.053611 43.763285 262.676395 24.717568 359.192064 0L426.619563 145.030059C359.192064 170.796971 318.112939 182.289237 254.754987 248.024235 191.397035 313.759232 186.723755 377.340075 186.723755 431.988736L473.764096 431.988736 473.764096 972.814933Z" fill="currentColor"/></svg>
          <p class="motto-text">追求卓越、专注专业、敢担善为、行稳致远、廉洁自律</p>
          <svg class="quote-mark right" viewBox="0 0 1195 1024" xmlns="http://www.w3.org/2000/svg"><path d="M1125.400405 972.814933 651.636395 972.814933 651.636395 631.106304C651.636395 491.702016 663.719168 382.333696 687.885227 302.997931 712.0512 223.662165 737.181781 170.700459 802.935893 107.231829 868.68992 43.763285 914.312789 24.717568 1010.828373 0L1078.255957 145.030059C1010.828373 170.796971 969.749333 182.289237 906.391381 248.024235 843.033429 313.759232 838.360149 377.340075 838.360149 431.988736L1125.400405 431.988736 1125.400405 972.814933ZM473.764096 972.814933 0 972.814933 0 631.106304C0 491.702016 12.082859 382.333696 36.248832 302.997931 60.414891 223.662165 85.545472 170.700459 151.299499 107.231829 217.053611 43.763285 262.676395 24.717568 359.192064 0L426.619563 145.030059C359.192064 170.796971 318.112939 182.289237 254.754987 248.024235 191.397035 313.759232 186.723755 377.340075 186.723755 431.988736L473.764096 431.988736 473.764096 972.814933Z" fill="currentColor"/></svg>
        </div>
      </div>
    </section>
    
    <!-- 右下角广告位 -->
    <div v-if="showAd && adList.length > 0" class="floating-ad-container">
      <div class="ad-card" :class="{ 'fade-in': showAd }">
        <button class="ad-close-btn" @click="closeAd" title="关闭">
          <i class="el-icon-close"></i>
        </button>
        <div class="ad-content" @click="handleAdClick">
          <transition name="fade" mode="out-in">
            {{ adList[currentAdIndex].value }}
            <img :key="currentAdIndex" :src="adList[currentAdIndex].value" class="ad-image">
          </transition>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getSubMenuList,getNewsList, getBannerList, getHomeBadAssets, getLabelListByType } from '@/api/menu'
import { Image } from 'element-ui';
export default {
  name: 'Home',
  data() {
    return {
      currentBanner: 0,
      bannerTimer: null,
      bannerSlides: [],
      hotAssets: [],
      companyNews: [],
      notices: [],
      partyDynamics: [],
      // 广告位数据
      showAd: true,
      adList: [],
      currentAdIndex: 0,
      adTimer: null,
      // 热门资产轮播
      currentAssetSlide: 0,
      assetSlideTimer: null
    }
  },
  computed: {
    assetsScode() {
      const menus = this.$store.state.menuList || [];
      const m = menus.find(item => item.path === '/assets');
      return m ? m.scode : '4';
    },
    newsScode() {
      const menus = this.$store.state.menuList || [];
      const m = menus.find(item => item.path === '/news');
      return m ? m.scode : '2';
    },
    chunkedHotAssets() {
      const size = 3;
      const chunks = [];
      for (let i = 0; i < this.hotAssets.length; i += size) {
        chunks.push(this.hotAssets.slice(i, i + size));
      }
      return chunks;
    }
  },
  mounted() {
    this.fetchSubMenus();
    this.startBannerTimer();
    this.fetchNews("sys_content_type_news_05");
    this.fetchNews("sys_content_type_news_01");
    this.fetchNews("sys_content_type_news_03");
    this.fetchBanner("default_home");
    this.fetchHomeBadAssets(9);
    this.fetchAds();
  },
  beforeDestroy() {
    if (this.bannerTimer) clearInterval(this.bannerTimer);
    if (this.adTimer) clearInterval(this.adTimer);
    this.stopAssetSlideTimer();
  },
  methods: {
    async fetchSubMenus() {
      try {
        const res = await getSubMenuList("ecc398d199b846e28392a132a23ff656")
      } catch (error) {
        console.error('获取子菜单失败:', error);
      }
    },
    startBannerTimer() {
      this.bannerTimer = setInterval(() => {
        if (this.bannerSlides.length > 1) {
          this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length
        }
      }, 4000)
    },
    prevBanner() {
      this.currentBanner = (this.currentBanner - 1 + this.bannerSlides.length) % this.bannerSlides.length
    },
    nextBanner() {
      this.currentBanner = (this.currentBanner + 1) % this.bannerSlides.length
    },
     formatDateParts(dateString) {
      // 处理空值
      if (!dateString) return { day: '', month: '' };
      
      try {
        // 统一处理方法：提取日期部分（第一个连续的数字组合）
        // 匹配格式：2022-08-24 或 2022-08-24 23:05:33
        const dateMatch = dateString.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
        
        if (dateMatch) {
          const year = dateMatch[1];
          const month = dateMatch[2].padStart(2, '0');
          const day = dateMatch[3].padStart(2, '0');
          
          return {
            day: day,
            month: month + '月'
          };
        }
        
        // 如果匹配失败，尝试用传统方法
        const datePart = dateString.split(' ')[0];
        const parts = datePart.split(/[-/]/);
        
        if (parts.length === 3) {
          const month = parts[1].padStart(2, '0');
          const day = parts[2].padStart(2, '0');
          
          return {
            day: day,
            month: month + '月'
          };
        }
        
        console.warn('Invalid date format:', dateString);
        return { day: '', month: '' };
        
      } catch (error) {
        console.error('Error formatting date:', error);
        return { day: '', month: '' };
      }
    },
    async fetchNews(sys_content_type) {
      try {
        let pageSize = 6;
        if (sys_content_type == 'sys_content_type_news_05' || sys_content_type == 'sys_content_type_news_03') {
           pageSize = 5;
        } else if (sys_content_type == 'sys_content_type_news_01') {
           pageSize = 2;
        }
        const res = await getNewsList({
          info_type: sys_content_type,
          keyword: '',
          pageNum: 1,
          pageSize: pageSize
        })
        if (res.code === 0) {
          if (sys_content_type == 'sys_content_type_news_05') {
            this.partyDynamics = res.rows || []
          } else if (sys_content_type == 'sys_content_type_news_01') {
            this.companyNews = res.rows || []
          } else if (sys_content_type == 'sys_content_type_news_03') {
            this.notices = res.rows || []
          }
        }
      } catch (error) {
        console.error('获取列表失败', error)
      }
    },
    async fetchBanner(groupCode) {
      try {
        const res = await getBannerList({ groupCode })
        if (res.code === 0) {
          this.bannerSlides = res.rows || []
        } 
      } catch (error) {
        console.error('获取轮播图失败', error)
      }
    },
    async fetchHomeBadAssets(pageSize) {
      try {
        const res = await getHomeBadAssets({ pageSize })
        console.log(res)
        if (res.code === 0) {
          this.hotAssets = res.rows || []
          if (this.hotAssets.length > 3) {
            this.startAssetSlideTimer();
          }
        } 
      } catch (error) {
        console.error('获取热门资产失败', error)
      }
    },
    async fetchAds() {
      try {
        const res = await getLabelListByType('6');
        if (res.code === 200 || res.code === 0) {
          this.adList = res.data || [];
          if (this.adList.length > 1) {
            this.startAdTimer();
          }
        }
      } catch (error) {
        console.error('获取广告失败', error);
      }
    },
    startAdTimer() {
        this.adTimer = setInterval(() => {
            if (this.adList.length > 1) {
                this.currentAdIndex = (this.currentAdIndex + 1) % this.adList.length;
            }
        }, 5000);
    },
    closeAd() {
      this.showAd = false;
      if (this.adTimer) clearInterval(this.adTimer);
    },
    handleAdClick() {
      const ad = this.adList[this.currentAdIndex];
      if (ad && ad.targetUrl) {
        window.open(ad.targetUrl, '_blank');
      }
    },
    startAssetSlideTimer() {
      this.stopAssetSlideTimer();
      if (this.chunkedHotAssets.length > 1) {
        this.assetSlideTimer = setInterval(() => {
          this.currentAssetSlide = (this.currentAssetSlide + 1) % this.chunkedHotAssets.length;
        }, 5000);
      }
    },
    stopAssetSlideTimer() {
      if (this.assetSlideTimer) {
        clearInterval(this.assetSlideTimer);
        this.assetSlideTimer = null;
      }
    },
    setAssetSlide(index) {
      this.currentAssetSlide = index;
      this.startAssetSlideTimer();
    },
    itemTagClass(item) {
      const tag = item.infoType || '';
      if (tag === 'sys_content_type_news_03') return 'tag-urgent';
      if (tag === 'sys_content_type_news_04') return 'tag-normal';
      if (tag === 'sys_content_type_news_02') return 'tag-end';
      return 'tag-normal';
    },
    getInfoTypeStr(infoType) {
      if (infoType === 'sys_content_type_news_03') return '处置公告';
      if (infoType === 'sys_content_type_news_04') return '资产推介会';
      if (infoType === 'sys_content_type_news_02') return '招标采购';
      return '';
    }
  },
  
}
</script>

<style lang="scss" scoped>
/* ---------- 全局重置 ---------- */
.home-page {
  width: 100%;
  overflow-x: hidden;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ---------- Banner ---------- */
.hero-banner {
  position: relative;
  width: 100%;
  height: 480px;
  overflow: hidden;

  .single-banner {
    width: 100%;
    height: 100%;
  }

  .banner-slider {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .banner-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.8s ease;

    &.active { opacity: 1; }

    .banner-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .banner-text-overlay {
      text-align: center;
      color: #fff;
      h2 { font-size: 2.4rem; font-weight: 700; margin-bottom: 12px; text-shadow: 0 2px 8px rgba(0,0,0,.4); }
      p  { font-size: 15px; opacity: .9; text-shadow: 0 1px 4px rgba(0,0,0,.3); }
    }
  }

  .banner-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255,255,255,.2);
    color: #fff;
    border: none;
    width: 44px; height: 44px;
    border-radius: 50%;
    font-size: 18px;
    cursor: pointer;
    transition: background .3s;
    z-index: 10;
    &:hover { background: rgba(255,255,255,.4); }
    &.banner-prev { left: 20px; }
    &.banner-next { right: 20px; }
  }

  .banner-dots {
    position: absolute;
    bottom: 16px;
    left: 50%; transform: translateX(-50%);
    display: flex; gap: 8px; z-index: 10;
    span {
      width: 10px; height: 10px;
      border-radius: 50%;
      background: rgba(255,255,255,.5);
      cursor: pointer; transition: background .3s;
      &.active { background: #fff; }
    }
  }
}

/* ---------- section-header ---------- */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .section-title {
    padding: 0px;
    font-size: 28px;
    font-weight: 600;
    position: relative;
    padding-left: 15px;
    color:#1a4a7a;
    border-left: 5px solid #d2ac79;
  }

  .view-more {
    color: #1e6fa2;
    text-decoration: none;
    font-size: .875rem;
    &:hover { text-decoration: underline; }
  }
}

/* ---------- 热门资产 ---------- */
.assets-section {
  padding: 60px 0;
  background: #f5f7fa;

  .assets-carousel-wrapper {
    position: relative;
    overflow: hidden;
    padding: 10px 5px 40px;
  }

  .assets-carousel-track {
    display: flex;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
  }

  .assets-slide {
    flex: 0 0 100%;
    width: 100%;
  }

  .assets-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
    
    &.solo-grid {
      padding: 5px;
    }
  }

  /* 详情版资产卡片 (参照 v6 index.html) */
  .asset-card-detailed {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,.06);
    transition: all .3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 30px rgba(0,0,0,.12);
      
      .asset-image img {
        transform: scale(1.08);
      }
    }

    .asset-image {
      position: relative;
      height: 220px;
      overflow: hidden;
      
      img {
        transition: transform .5s ease;
      }
      
      .asset-tag {
        position: absolute;
        top: 5px;
        left: 5px;
        border-radius: 4px;
        font-size: .75rem;
        font-weight: 600;
        color: #fff;
        z-index: 2;
        
        &.tag-hot  { background: #e74c3c; box-shadow: 0 2px 8px rgba(231,76,60,.4); }
      }
    }

    .asset-info {
      padding: 20px;
      flex: 1;
      display: flex;
      flex-direction: column;

      h3 {
        font-size: 15px;
        font-weight: 700;
        color: #1a3a5c;
        margin-bottom: 12px;
        line-height: 1.4;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .asset-meta {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
        font-size: 12px;
        color: #777;
        margin-bottom: 15px;
        
        .addr-span {
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          i { margin-right: 5px; color: #1e6fa2; flex-shrink: 0; }
        }

        .tag-span {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          margin-left: 5px;
          i { margin-right: 5px; color: #1e6fa2; }
        }
      }

      .asset-details {
        border-top: 1px solid #f0f0f0;
        padding-top: 15px;
        margin-bottom: 15px;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 8px;
        
        .detail-item {
          display: flex;
          flex-direction: column;
          gap: 2px;
          
          .label {
            font-size: 12px;
            color: #999;
            text-transform: uppercase;
          }
          .value {
            font-size: .85rem;
            color: #333;
            font-weight: 600;
          }
        }
      }

      .asset-footer {
        margin-top: auto;
        padding-top: 15px;
        border-top: 1px dashed #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .asset-price {
          .price-label {
            font-size: .7rem;
            color: #999;
            display: block;
            margin-bottom: 2px;
          }
          .price-value {
            font-size: 12px;
            font-weight: 700;
            color: #e4393c;
          }
        }

        .btn-view {
          background: #fff;
          color: #1a3a5c;
          border: 1px solid #1a3a5c;
          padding: 5px 12px;
          border-radius: 4px;
          text-decoration: none;
          font-size: 0.85rem;
          transition: all 0.2s;

          &:hover {
            background: #1a3a5c;
            color:#fff;
          }
        }
      }
    }
  }

  /* 轮播指示器圆点 */
  .assets-carousel-dots {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    
    span {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #ddd;
      cursor: pointer;
      transition: all .3s ease;
      
      &.active {
        background: #1e6fa2;
        width: 25px;
        border-radius: 5px;
      }
    }
  }
}

/* ---------- 新闻公告 ---------- */
.news-section {
  padding: 60px 0;
  background: #fdfdfd;

  .news-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 40px;
  }

  .news-block {
    min-width: 0;
    .block-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      h3 { 
        padding: 0px;
        font-size: 28px;
        font-weight: 600;
        position: relative;
        padding-left: 15px;
        color:#1a4a7a;
        border-left: 5px solid #d2ac79;
      }
      .more-link { 
        color: #1e6fa2;
        text-decoration: none;
        font-size: .875rem;
        &:hover { text-decoration: underline; }
      }
    }

    .news-list {
      padding: 20px 25px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.05);
      border: 1px solid #f0f0f0;
    }

    .news-item.featured {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-bottom: 0px;
      padding-bottom: 10px;
      border-bottom:1px solid #e0e0e0;
      cursor: pointer;

      .news-image-featured {
        width: 100%;
        height: 200px;
        border-radius: 8px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }
      }
      
      &:hover .news-image-featured img {
        transform: scale(1.05);
      }

      .news-content-featured {
        h4 a { 
          font-size: 16px; 
          font-weight: 700;
          color: #333; 
          line-height: 1.4; 
          margin-bottom: 8px; 
          text-decoration: none;
          &:hover { color: #1e6fa2; }
        }
        .news-date { font-size: 12px; color: #999; }
      }
    }

    .news-item.list-item {
      display: flex; 
      align-items: center; 
      gap: 12px;
      padding: 25px 0; 
      border-bottom: 1px solid #e0e0e0;
      &:last-child { border-bottom: none; }
      
      .news-dot { 
        width: 5px; 
        height: 5px; 
        border-radius: 50%; 
        background: #d2ac79; 
        flex-shrink: 0; 
      }
      
      .tag {
        padding: 2px 10px;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 600;
        flex-shrink: 0;
        &.tag-urgent { background: #fff1f0; color: #e74c3c; }
        &.tag-normal { background: #e6f7ff; color: #1e6fa2; }
        &.tag-end    { background: #e4f7e2; color: #3b9903; }
      }

      a {
        flex: 1;
        min-width: 0;
        font-size: 14px;
        color: #444; 
        text-decoration: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:hover { color: #1e6fa2 !important; }
      }
      
      .news-date {
         flex-shrink: 0;
         font-size: 12px;
         color: #bbb;
         margin-left: 15px;
      }
    }
  }
}

/* ---------- 企业党建 ---------- */
.party-section {
  padding: 60px 0;
  background: #f5f7fa;

  .dynamics-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
    gap: 30px;
  }

  .dynamic-card.featured {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.05);
    cursor: pointer;
    transition: transform 0.3s;
    border: 1px solid #f0f0f0;
    text-decoration: none;
    
    // &:hover {
    //   transform: translateY(-5px);
    // }

    .dynamic-image {
      position: relative;
      height: 280px;
      overflow: hidden;
      
      .dynamic-tag {
        position: absolute;
        top: 15px;
        left: 15px;
        background: #c0392b;
        color: #fff;
        padding: 4px 15px;
        border-radius: 4px;
        font-size: .85rem;
        font-weight: 600;
        z-index: 2;
      }
    }

    .dynamic-content {
      padding: 19px;
      h4 { 
        font-size: 16px; 
        font-weight: 700; 
        color: #333; 
        line-height: 1.4; 
        margin-bottom: 15px; 
        &:hover { color: #c0392b !important; }
      }
      p  { 
        font-size: 14px; 
        color: #666; 
        line-height: 1.6; 
        margin-bottom: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .dynamic-meta { 
        font-size: .85rem; 
        color: #999; 
        display: flex; 
        gap: 20px;
        i { margin-right: 5px; color: #bbb; }
      }
    }
  }

  .dynamic-list {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .dynamic-item {
      display: flex;
      gap: 15px;
      background: #fff;
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 4px 15px rgba(0,0,0,0.03);
      cursor: pointer;
      transition: all 0.3s;
      border: 1px solid #f8f8f8;
      
      // &:hover {
        // transform: translateX(8px);
        // box-shadow: 0 8px 25px rgba(0,0,0,0.08);
      // }

      .dynamic-date {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 40px;
        height: 60px;
        background: #c41e3a;
        border-radius: 8px;
        color: #fff;
        flex-shrink: 0;
        
        .day { 
          font-size: 20px; 
          font-weight: 700; 
          line-height: 1;
        }
        .month { 
          font-size: 12px; 
          opacity: 0.8;
          margin-top: 2px;
        }
      }

      .dynamic-info {
        flex: 1;
        min-width: 0;
        h5 { 
          font-size: 14px; 
          font-weight: 700; 
          margin-bottom: 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          a { color: #1a3a5c; text-decoration: none; &:hover { color: #c0392b !important; } }
        }
        p { 
            font-size: 12px;
            color :#666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.4;
            max-height: 2.8em;
        }
      }
    }
  }
}
.asset-stats {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 0.75rem;
  color: #999;
  
}
.tag-recommend {
  border: none;
  font-weight: 700;
  padding: 3px 10px;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(255,140,0,0.4);
  border-radius: 4px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.2);
  font-size: 0.8rem;
  background: linear-gradient(135deg, #ffaa00 0%, #e4393c 100%);
  box-shadow: 0 2px 8px rgba(228,57,60,.4);
  color:#fff;
}
.tag {
  display: inline-block;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: 8px;
  vertical-align: middle;
  font-weight: normal;
}

.tag-top {
  color: #dbb523 !important;
}
/* ---------- 企业理念 ---------- */
/* ---------- 企业理念 ---------- */
.motto-section {
  padding: 100px 0;
  background: #f8f9fa;
  border-top: 1px solid #f0f0f0;

  .motto-quote {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    max-width: 900px;
    margin: 0 auto;

    .quote-mark {
      width: 50px;
      height: 50px;
      color: #e5e9ef;
      flex-shrink: 0;
      
      &.left {
         transform: translateY(-10px);
      }
      &.right {
         transform: rotate(180deg) translateY(-10px);
      }
    }

    .motto-text {
      color: #1a3a5c;
      font-size: 28px;
      font-weight: 700;
      letter-spacing: 0.1em;
      text-align: center;
      line-height: 1.6;
      word-break: keep-all;
    }
  }
}

/* ============= Tablet (768–1023px) ============= */
@media (max-width: 1023px) {
  .hero-banner { 
    height: 260px;
    margin: 0;
    padding: 0;
  }
  .hero-banner .banner-slide .banner-text-overlay h2 { font-size: 1.8rem; }

  .assets-section {
    padding-top: 30px;
  }
  .assets-section .assets-grid { grid-template-columns: repeat(2, 1fr); }

  .party-section .dynamics-grid { grid-template-columns: minmax(0, 1fr); }
  .party-section .dynamic-card.featured, .party-section .dynamic-list { width: 100%; box-sizing: border-box; }
  .party-section .dynamic-card.featured .dynamic-image { height: 240px; }

  .motto-section .motto-quote .motto-text { font-size: 1.15rem; }
}

/* ============= Mobile (≤ 767px) ============= */
@media (max-width: 767px) {
  .hero-banner {
    height: 120px;
    margin: 0;
    padding: 0;
    .banner-slide .banner-text-overlay {
      h2 { font-size: 1.2rem; }
      p  { font-size: .85rem; }
    }
    .banner-arrow { width: 40px; height: 40px; font-size: 16px; } /* 增大触摸区域 */
  }

  .assets-section {
    padding-top: 20px;
  }

  .section-header {
    .section-title { font-size: 22px; }
    .view-more { padding: 5px 0; display: inline-block; } /* 增大触摸区域 */
  }

  .assets-section .assets-grid { grid-template-columns: 1fr; gap: 16px; }
  .assets-section .asset-card-detailed .asset-image { height: 200px; }
  .assets-section .asset-card-detailed .asset-footer .btn-view { padding: 10px 20px; font-size: 14px; } /* 增大移动端按钮触摸区域 */

  .news-section .news-grid { grid-template-columns: 1fr; gap: 30px; }
  .news-section .news-item.featured .news-image-featured { height: 160px; } /* 适配全宽高度 */
  .news-section .news-item.list-item { padding: 15px 0; } /* 适配触控间距 */

  .party-section .dynamics-grid { grid-template-columns: minmax(0, 1fr); }
  .party-section .dynamic-card.featured .dynamic-image { height: 200px; }
  .party-section .dynamic-card.featured .dynamic-content { padding: 15px; }
  .party-section .dynamic-list .dynamic-item { padding: 15px; }

  .motto-section .motto-quote {
    flex-direction: column; gap: 12px;
    .quote-mark { width: 35px; height: 35px; }
    .motto-text  { font-size: .95rem; letter-spacing: .05em; padding: 0 10px; }
  }
}
/* ---------- 广告弹窗 ---------- */
.floating-ad-container {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 2000;
  pointer-events: auto;
}

.ad-card {
  width: 320px;
  max-width: 90vw;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  position: relative;
  overflow: hidden;
  border: 1px solid #eee;
  
  &.fade-in {
    animation: slideUp 0.5s ease-out;
  }
}

@keyframes slideUp {
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.ad-close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0,0,0,0.3);
  color: #fff;
  border: none;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  
  &:hover {
    background: rgba(0,0,0,0.6);
  }
  
  i { font-size: 14px; }
}

.ad-content {
  cursor: pointer;
  aspect-ratio: 4 / 3;
  width: 100%;
  
  .ad-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

/* 广告切换动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@media (max-width: 767px) {
  .floating-ad-container {
    display: none;
  }
  .ad-card {
    width: 200px;
  }
  .ad-close-btn {
    width: 32px;
    height: 32px; /* 增大移动端关闭广告按钮尺寸 */
    i { font-size: 18px; }
  }
}
</style>
